import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme';

/** Google "Sign in with Google" dark theme colors (brand guidelines) */
const GOOGLE_DARK_BG = '#131314';
const GOOGLE_DARK_BORDER = '#131314';

export const GoogleButtonWrapper = styled.div`
  margin-top: 16px;
  position: relative;
  width: 100%;
  height: 44px;
`;

export const GoogleButtonContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  cursor: pointer;
`;

export const CustomGoogleButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Google Sans', sans-serif;
  gap: 8px;
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dadce0;
  color: #3c4043;
  outline: none;
  font-weight: 500;
  letter-spacing: 0.25px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;
  z-index: 2;
  pointer-events: none;
  max-width: 400px;
  margin: 0 auto;

  ${darkMode(css`
    background-color: ${GOOGLE_DARK_BG};
    border-color: ${GOOGLE_DARK_BORDER};
    color: ${darkPalette.textPrimary};
  `)}
`;

export const GoogleLogo = styled.img`
  width: 24px;
  height: 24px;
`;

export const Separator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0;
  font-size: 14px;
  color: #848484;
  width: 100%;

  span {
    margin: 0 10px;
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }

  &::before,
  &::after {
    content: '';
    display: block;
    height: 1px;
    width: 100px;
    background-color: #e9e9e9;
  }

  ${darkMode(css`
    color: ${darkPalette.textTertiary};

    &::before,
    &::after {
      background-color: ${darkPalette.border};
    }
  `)}
`;
